import React from 'react';
// import WwunionLogo from 'assets/images/wwunion-logo.png';
import WwunionLogo from 'assets/images/retina-01-1.png';
// import EnsureLogo from 'assets/images/ensure-logo.png';
import WwunionAppQrcode from 'assets/images/app-qr-code.png';
import { IProps } from './types';
import _ from 'lodash';
import { CodeId } from 'constants/enums/codeId.enum';
import { Link } from 'bff/models/link';
import commonService from 'utils/commonService';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const Footer: React.FC<IProps> = (props) => {
  /**
   * @description 根據路徑下載檔案
  */
  const handleDownloadFile = (e:React.MouseEvent<HTMLAnchorElement>, linkUrl:string) => {
    e.preventDefault();

    try {
      commonService.downloadFile(linkUrl, e.currentTarget.innerText);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };

  /**
   * @description 建立 footer 項目
  */
  const handleCreateLink = (link:Link) => {
    const linkTarget = commonService.getLinkTarget(link.NEW_WINDOW);
    const linkUrl = commonService.validLoginState(link.LOGIN_REQUIRED, link.URL);
    if (link.URL.indexOf('.pdf') === -1) {
      return <a href={linkUrl} target={linkTarget} rel="noopener noreferrer">{link.NAME}</a>;
    }

    return <a href={linkUrl} target={linkTarget} onClick={(e:React.MouseEvent<HTMLAnchorElement>) => handleDownloadFile(e, linkUrl)} rel="noopener noreferrer">{link.NAME}</a>;
  };

  // #region 建立 footer 、 mobile 項目

  let footerItems = null;
  let footerMobileItems;
  let border;
  if (props.footerLinks.length > 0) {
    const borderCount = props.footerLinks.length - 1;
    footerItems = _.map(props.footerLinks, (footerLink:Link, index:number) => {
      border = null;
      if (index < borderCount) border = <hr />;
      return React.cloneElement((
        <>
          {
            handleCreateLink(footerLink)
          }
          {border}
        </>
      ), { key: index });
    });

    footerMobileItems = _.map(props.footerLinks, (footerLink:Link, index:number) => {
      return (
        <span key={index}>
          {
            handleCreateLink(footerLink)
          }
        </span>
      );
    });
  }

  // #endregion

  return (
    <footer>
      <div className="footer">
        <div className="template-container">
          <div className="footer__content">
            <div className="footer__row">
              <div className="footer__logos">
                <div className="footer__wwunion-logo">
                  <img src={WwunionLogo} alt="wwunion" />
                </div>
                {
                  /*
                    <hr />
                    <div className="footer__ensure-logo">
                      <img src={EnsureLogo} alt="wwunion-ensure" />
                    </div>
                  */
                }
              </div>
              <p>
                {commonService.getCodeMsg(props.codeTables, CodeId.U005)}<br />
                {commonService.getCodeMsg(props.codeTables, CodeId.U006)}
              </p>
              <p>
                {commonService.getCodeMsg(props.codeTables, CodeId.U007)}<br />
                {commonService.getCodeMsg(props.codeTables, CodeId.U008)}
              </p>
              <div className="footer__apps">
                <div className="footer__third-party-app">
                  <a href="https://www.facebook.com/wwunion/" rel="noopener noreferrer" target="_blank">
                    <i className="footer__wwunion-facebook" />
                  </a>
                  <a href="https://line.me/ti/p/@wwunion" rel="noopener noreferrer" target="_blank">
                    <i className="footer__wwunion-line" />
                  </a>
                  <a href="https://www.youtube.com/@user-zr7sr9hr1x/featured" rel="noopener noreferrer" target="_blank">
                    <i className="footer__wwunion-youtube" />
                  </a>
                </div>
                {/*<div className="footer__wwunion-app">*/}
                {/*  <span>旺旺友聯 APP</span>*/}
                {/*  <img src={WwunionAppQrcode} alt="wwunion-app" />*/}
                {/*</div>*/}
              </div>
            </div>
            <div className="footer__row">
              <div className="footer__info">
                {footerItems}
              </div>
              <small className="footer__copyright">{commonService.getCodeMsg(props.codeTables, CodeId.U009)}</small>
            </div>
            <div className="footer__row footer__row__browser-info">
              <small className="footer__browser-info">{commonService.getCodeMsg(props.codeTables, CodeId.U021)}</small>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-mobile__info">
        {footerMobileItems}
      </div>
    </footer>
  );
};

export default Footer;
